import { action, makeObservable, observable } from "mobx";
import { DialogState, IDialogState } from "../../../../stores/models/DialogState";

export class ConfirmationDialogState extends DialogState {
    @observable confirmed: boolean | undefined;

    constructor(dialogState?: IDialogState) {
        super(dialogState);
        makeObservable(this);
    }

    @action setConfirmed(confirmed: boolean) {
        this.confirmed = confirmed;
    }

    @action reset() {
        this.confirmed = undefined;
    }
}